import moment from 'moment';

export function safelyCreateDate (date, format = 'YYYY-MM-DD HH:mm') {
	return moment(date, format).toDate();
}
